/**
 * Sélection du backend cloud :
 * - `?mockcloud=1` → backend simulé (dev/e2e, sans réseau ni Firebase) ;
 * - sinon, si `VITE_FIREBASE_CONFIG` est présent → Firebase (Auth + Firestore) ;
 * - sinon → `null` : le compte cloud est indisponible (le jeu reste 100 % jouable).
 *
 * Importer `FirebaseBackend` ici n'embarque PAS le SDK Firebase dans le bundle initial :
 * la classe est légère et charge le SDK par `import()` dynamique dans son `init()`.
 */
import type { CloudBackend } from './types';
import { firebaseConfig } from './config';
import { MockCloudBackend } from './mock';
import { FirebaseBackend } from './firebase';

let backend: CloudBackend | null | undefined;

export function getCloudBackend(): CloudBackend | null {
  if (backend !== undefined) return backend;
  if (typeof location !== 'undefined' && /[?&]mockcloud=1/.test(location.search)) {
    backend = new MockCloudBackend();
  } else {
    const cfg = firebaseConfig();
    backend = cfg ? new FirebaseBackend(cfg) : null;
  }
  return backend;
}
